<template>
  <div class="order-filter-audit">
    <div class="tuolele-main-box">
      <div class="tuolele-main-search">
        <el-form :inline="true" :model="search">
          <el-form-item label="选择店铺">
            <el-select v-model="search.shop_id" @change="updateFilter()">
              <el-option label="全部" value="0" />
              <el-option
                v-for="item in shopList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <!-- <el-form-item v-if="type == 'signingAudit'" label="付款方式">
            <el-select v-model="search.payment">
              <el-option label="全部" value />
              <el-option label="支付宝" value="f2f" />
              <el-option label="微信" value="wxqr" />
              <el-option label="POS支付" value="lkl" />
              <el-option label="直接转账" value="turn" />
              <el-option label="现金支付" value="cash" />
              <el-option label="余额支付" value="balance" />
              <el-option label="大众点评" value="dianping" />
            </el-select>
          </el-form-item> -->
          <!-- <el-button
            type="primary"
            class="el-button-confirm"
            @click="updateFilter"
          >查询</el-button> -->
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderFilter',
  props: {
    type: String
  },
  data() {
    return {
      search: {
        p: 1,
        limit: 10,
        shop_id: '',
        payment: '',
        give_type: '0'
      },
      shopList: [],
      giveType: []
    }
  },
  created() {
    if (this.type == 'signingAudit') {
      this.search.status = '1'
      this.search.give_type = '0'
    } else if (this.type == 'refundAudit') {
      this.search.status = '2'
      this.search.give_type = ''
    } else if (this.type == 'convertedAudit') {
      this.search.status = '2,6'
      this.search.give_type = ''
    }
  },
  mounted() {
    this.getGiveType()
    this.getMyShopList()
  },
  methods: {
    getGiveType() {
      this.$http.getGiveType().then(res => {
        this.giveType = res.data
      })
    },
    getMyShopList() {
      this.$http.getMyShopList().then(res => {
        this.shopList = res.data
      })
    },
    updateFilter() {
      this.$emit('updateFilter', this.search)
    }
  }
}
</script>

<style lang="scss">
.order-filter-audit {
  .tuolele-main-search {
    margin-bottom: 0;
    margin-top: 30px;
    padding: 0;
    border: 0;
    .el-select,
    .el-input {
      width: 180px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 20px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
